import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ListAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"list_alt"}/>
}
